export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "index-c9d841e86968b9b7d450.worker.js");
}
